export function publishedAt(hoursAgo: number) {
  return new Date(Date.now() - hoursAgo * 3_600_000);
}

export function timeAgo(hoursAgo: number) {
  if (hoursAgo < 1) return "Just now";
  if (hoursAgo < 24) return `${hoursAgo} ${hoursAgo === 1 ? "hour" : "hours"} ago`;
  const days = Math.floor(hoursAgo / 24);
  return `${days} ${days === 1 ? "day" : "days"} ago`;
}

export function longDate(d: Date) {
  return d.toLocaleDateString("en-IN", { weekday: "long", month: "long", day: "numeric", year: "numeric" });
}

export function stamp(hoursAgo: number) {
  const d = publishedAt(hoursAgo);
  return `${d.toLocaleDateString("en-IN", { month: "short", day: "numeric", year: "numeric" })}, ${d.toLocaleTimeString("en-IN", { hour: "numeric", minute: "2-digit" })} IST`;
}

export function inr(n: number) {
  return "₹" + Math.round(n).toLocaleString("en-IN");
}
